import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { holidaysAPI } from '../services/api';

export const useHolidays = () => {
  const queryClient = useQueryClient();

  // Get all holidays
  const {
    data: holidays = [],
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['holidays'],
    queryFn: () => holidaysAPI.getAll(),
  });

  // Create holiday mutation
  const createHoliday = useMutation({
    mutationFn: holidaysAPI.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['holidays'] });
    },
  });

  // Update holiday mutation
  const updateHoliday = useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) => 
      holidaysAPI.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['holidays'] });
    },
  });

  // Delete holiday mutation
  const deleteHoliday = useMutation({
    mutationFn: holidaysAPI.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['holidays'] });
    },
  });

  return {
    holidays,
    isLoading,
    error,
    refetch,
    createHoliday: createHoliday.mutate,
    updateHoliday: updateHoliday.mutate,
    deleteHoliday: deleteHoliday.mutate,
    isCreating: createHoliday.isPending,
    isUpdating: updateHoliday.isPending,
    isDeleting: deleteHoliday.isPending,
  };
};

export const useHolidaysByYear = (year: number) => {
  const {
    data: holidays = [],
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['holidays', year],
    queryFn: () => holidaysAPI.getByYear(year),
    enabled: !!year,
  });

  return {
    holidays,
    isLoading,
    error,
    refetch,
  };
};
